export const MODAL_CONFIG = {
  // Modal dimensions
  width: 300,
  height: 400, // Fixed pixel height for scrollable content

  // Positioning preferences
  preferredSide: 'right' as 'right' | 'left' | 'top' | 'bottom',
  offset: 12, // Gap between node edge and modal (in pixels)

  // Node dimensions (must match FlowNode circle size)
  nodeRadius: 36, // Half of 72px circle
} as const;
